import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import { NumericFormat } from 'react-number-format';
import Loading from "../../components/loading";
import Sheet from '@mui/joy/Sheet';
import ModalViewDayFCI from "./modals/modalViewDayFCI"
import ModalViewDayObservations from "./modals/modalViewDayObservation";
import { usePusherChannel } from '../../context/PusherContext';
import moment from 'moment';
//SERVICES  
import FundService from "../../services/fundService";


function MesaDayOperationsFCI() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const initialized = useRef(false)
    const [listOperations, setListOperations] = useState([])
    const [modalViewOpen, setModalViewOpen] = useState(false);
    const [modalViewObservationsOpen, setModalViewObservationsOpen] = useState(false);
    const [bonoSelected, setBonoSelected] = useState('');
    // const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            doSearch()
        }
    }, [false]);

    usePusherChannel('fund-operations-channel', 'pending',  () => { doSearch().then() });
    usePusherChannel('fund-operations-channel', 'blocked',  () => { doSearch().then() });
    usePusherChannel('fund-operations-channel', 'finished', () => { doSearch().then() });
    usePusherChannel('fund-operations-channel', 'cancel',   () => { doSearch().then() });

    const doSearch = async (event) => {
        try {  
            setLoading(true)
            const response = await FundService.getFundOperationToday()
            setListOperations(response.data)            
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }
    
    const doView = async (obj) => {
        if(obj !== null){
            setBonoSelected(obj)
            setModalViewOpen(true)
        }
    }

    const doConfirmOpe = async (obj) => {
        if(obj !== null){
            Swal.fire({
                title: 'Atención!',
                text: "Ud. esta seguro que quiere FINALIZAR la operación ?",
                icon: 'warning',
                confirmButtonText: "Continuar",
                confirmButtonColor: "#83766d",
                showCancelButton: true,
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) { doChangeStatus(obj, 5); }
            });
            
        }
    }

    const doCancelOpe = async (obj) => {
        if(obj !== null){
            if(obj !== null){
                Swal.fire({
                    title: 'Atención!',
                    text: "Ud. esta seguro que quiere RECHAZAR la operación ?",
                    icon: 'warning',
                    confirmButtonText: "Continuar",
                    confirmButtonColor: "#83766d",
                    showCancelButton: true,
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) { doChangeStatus(obj, 4); }
                });
                
            }
        }
    }

    const doUnlock = async (obj) => {
        if(obj !== null){
            Swal.fire({
                title: "Atención!",
                text: "Ud. esta seguro que quiere DESBLOQUEAR la operación ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#83766d",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) { doChangeStatus(obj, 1) }
            });
        }
    }

    const doNote = async (obj) => {
        if(obj !== null){
            setBonoSelected(obj)
            setModalViewObservationsOpen(true)
        }
    }

    const doChangeStatus = async (obj, statusid) => {
        if(obj !== null){
            try {
                setLoading(true)
                const response = await FundService.putFundStatus(obj.id,{operation_state_id: statusid})
            } catch (err) {
                if(err.response.status !== 401){
                    Swal.fire({
                        title: 'Ooops?',
                        text: err.response.data.errors[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            } finally{ setLoading(false) }
        }
    }

    if(loading){
        return(
            <Loading></Loading>
        )
    }


    return ( 
        <div className="row">

            <div className="row">
                <Sheet sx={{ height: 580, overflow: 'auto', backgroundColor: 'transparent', padding: '2px' }} className="table-responsive">
                    <table className="table table-striped table-hover" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>#</th>
                                <th>Hora</th>
                                <th>Comintente</th>
                                <th>Tipo Operación</th>
                                <th>Fondo</th>
                                <th>Plazo</th>
                                <th>Tipo</th>
                                <th>Cantidad/Monto</th>
                                <th>Comercial</th>
                                <th>Estado</th>
                                <th>ACDI</th>
                                <th>Observaciones</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {listOperations.map(operation => {
                                return (
                                    <tr key={operation.id}>  
                                        <td><small>{operation.id}</small></td>
                                        <td><small className="text-muted">{moment(operation.created_at).format('HH:mm')}</small></td>
                                        <td>
                                            <small>
                                                <div className="d-flex justify-content-start align-items-center user-name">
                                                    <div className="d-flex flex-column">
                                                        <a className="text-body text-truncate">
                                                            <span className="fw-medium">
                                                                {operation.account_model.name.length > 30 ?
                                                                    `${operation.account_model.name.substring(0, 30)}...` : operation.account_model.name
                                                                }
                                                            </span>
                                                        </a>
                                                        <small className="text-muted"><span className="badge bg-label-dark">{operation.account_model.account}</span></small>
                                                    </div>
                                                </div>
                                            </small>
                                        </td>
                                        <td>
                                            {operation.operation_type_id === 3 && <span className="badge bg-label-success me-1">{operation.operation_type.name}</span>}
                                            {operation.operation_type_id === 4 && <span className="badge bg-label-danger me-1">{operation.operation_type.name}</span>}
                                        </td>
                                        <td>
                                            <small>
                                                <div className="d-flex justify-content-start align-items-center user-name">
                                                    <div className="d-flex flex-column">
                                                        <a className="text-body text-truncate">
                                                            <span className="fw-medium">
                                                                {operation.fund.name.length > 30 ?
                                                                    `${operation.fund.name.substring(0, 30)}...` : operation.fund.name
                                                                }
                                                            </span>
                                                        </a>
                                                        <small className="text-muted"><span className="badge bg-label-dark">{operation.currency.name}</span></small>
                                                    </div>
                                                </div>
                                            </small>
                                        </td>
                                        <td><small>{operation.settlement_term.name}</small></td>
                                        <td><small>{operation.investment_mode.name}</small></td>
                                        <td className="text-end">
                                            {operation.investment_mode_id === 1 ?
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={operation.amount} 
                                                    decimalScale={2} 
                                                    allowLeadingZeros 
                                                    thousandSeparator="." 
                                                    decimalSeparator="," 
                                                    prefix={'$'}  
                                                /> 
                                            :
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={operation.qty} 
                                                    decimalScale={0} 
                                                    allowLeadingZeros 
                                                    thousandSeparator="." 
                                                    decimalSeparator="," 
                                                /> 
                                            }
                                        </td>
                                        <td><small>{operation.user.full_name}</small></td>
                                        <td>
                                            {operation.operation_state_id === 1 && <span className="badge bg-label-secondary me-1">{operation.operation_state.display_name}</span>}
                                            {operation.operation_state_id === 2 && <span className="badge bg-label-warning me-1">{operation.operation_state.display_name}</span>}
                                            {operation.operation_state_id === 3 && <span className="badge bg-label-success me-1">{operation.operation_state.display_name}</span>}
                                            {operation.operation_state_id === 4 && <span className="badge bg-label-danger me-1">{operation.operation_state.display_name}</span>}
                                        </td>
                                        <td>
                                            <small>
                                                {operation.is_acdi ?
                                                    <span className="badge bg-label-success me-1">Si</span>
                                                :
                                                    <span className="badge bg-label-danger me-1">No</span>
                                                }
                                            </small>
                                        </td>
                                        <td><small>{operation.observations}</small></td>
                                        <td  className="text-start">
                                            {operation.operation_state_id === 1 &&
                                                <a href="#" title="Tomar Operación" onClick={() => { doChangeStatus(operation, 2) } }>
                                                    <i className='bx bxs-hand'></i>
                                                </a> 
                                            }
                                            {operation.operation_state_id === 2 &&
                                                <>
                                                    <a href="#" title="Confirmar Operación" onClick={() => { doConfirmOpe(operation) } }>
                                                        <i className='bx bx-check-circle' style={{color:'green'}}></i>
                                                    </a> 
                                                    <a href="#" title="Rechazar Operación" onClick={() => { doCancelOpe(operation) } }>
                                                        <i className='bx bx-x-circle' style={{color:'red'}}></i>
                                                    </a> 
                                                </>
                                            }
                                            {operation.observations !== null &&
                                                <a href="#" title="Comentarios" onClick={() => { doNote(operation) } }>
                                                    <i className='bx bx-message-square-dots' ></i>
                                                </a> 
                                            }
                                        </td>
                                        <td className="text-end">
                                            <div className="dropdown">
                                                <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                                    <i className="bx bx-dots-vertical-rounded" />
                                                </button>
                                                <div className="dropdown-menu">
                                                    <a className="dropdown-item" href="#"  onClick={() => {  doView(operation) } }>
                                                        <i className="bx bx-eyes me-1" /> Ver
                                                    </a>
                                                    {operation.operation_state_id === 2 &&
                                                        <>
                                                            <a className="dropdown-item" href="#"  onClick={() => { doUnlock(operation) } }>
                                                                Desbloquear
                                                            </a>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </Sheet>
            </div>

            { bonoSelected !== '' ?
                <>  
                    <ModalViewDayFCI 
                        handleOpen={setModalViewOpen} 
                        isOpen={modalViewOpen} 
                        selected={bonoSelected}
                        setSelected={setBonoSelected}
                        fundId={bonoSelected.id}
                        refresh={doSearch}
                    />

                    <ModalViewDayObservations 
                        handleOpen={setModalViewObservationsOpen} 
                        isOpen={modalViewObservationsOpen} 
                        selected={bonoSelected}
                        opeId={bonoSelected.id}
                    />
                </>
            
            :
                null
            }


        </div>
     );

}

export default MesaDayOperationsFCI;